(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire93c1"];
var parcelRegister = parcelRequire.register;
parcelRegister("btVOq", function(module, exports) {

$parcel$export(module.exports, "testimonialsSlider", function () { return $85bf3f78f0b243e1$export$4f0d537070d9433f; });
$parcel$export(module.exports, "scrollTo", function () { return $85bf3f78f0b243e1$export$3f99968195accfaf; });

var $9kA8B = parcelRequire("9kA8B");

var $2O6Go = parcelRequire("2O6Go");

var $cQ97C = parcelRequire("cQ97C");

const $85bf3f78f0b243e1$export$4f0d537070d9433f = (slider)=>{
    if (slider.querySelectorAll(".swiper-slide").length > 1) {
        const swiper = new (0, $9kA8B.default)(slider, {
            modules: [
                (0, $2O6Go.Mousewheel)
            ],
            direction: "vertical",
            slidesPerView: 1,
            autoHeight: true,
            mousewheel: {
                releaseOnEdges: true,
                sensitivity: 0.05
            },
            mousewheelControl: true,
            touchReleaseOnEdges: true,
            speed: 600,
            on: {
                slideChange: function() {
                    setTimeout(function() {
                        swiper.params.mousewheel.releaseOnEdges = false;
                    }, 500);
                },
                reachEnd: function() {
                    setTimeout(function() {
                        swiper.params.mousewheel.releaseOnEdges = true;
                    }, 750);
                }
            }
        });
    }
};
const $85bf3f78f0b243e1$export$3f99968195accfaf = (element)=>{
    const parent = element.closest(".praxent_testimonials");
    const slides = element.querySelectorAll(".swiper-slide");
    if (slides.length > 1) {
        const parentOffset = parent.offsetTop;
        (0, $cQ97C.inView)(parent, ()=>{
            console.log("Element has entered the viewport");
            window.scrollTo({
                top: parentOffset - 92,
                behavior: "smooth"
            });
        }, {
            margin: "-300px"
        });
    }
};

});
parcelRegister("cQ97C", function(module, exports) {

$parcel$export(module.exports, "inView", function () { return $95916ace176e13ee$export$acb1e9cb9ce4ca56; });

var $jcurC = parcelRequire("jcurC");

var $1BJop = parcelRequire("1BJop");
const $95916ace176e13ee$var$thresholds = {
    any: 0,
    all: 1
};
function $95916ace176e13ee$export$acb1e9cb9ce4ca56(elementOrSelector, onStart, { root: root, margin: rootMargin, amount: amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */ if (typeof IntersectionObserver === "undefined") return ()=>{};
    const elements = (0, $jcurC.resolveElements)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if ((0, $1BJop.isFunction)(newOnEnd)) activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : $95916ace176e13ee$var$thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}

});
parcelRegister("jcurC", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $dfa6c0f8dc3dbbd0$export$90ceba2564a894f8; });
function $dfa6c0f8dc3dbbd0$export$90ceba2564a894f8(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = document.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}

});

parcelRegister("1BJop", function(module, exports) {

$parcel$export(module.exports, "isFunction", function () { return $12bc753290b100a8$export$f6e2535fb5126e54; });
const $12bc753290b100a8$export$f6e2535fb5126e54 = (value)=>typeof value === "function";

});



})();
//# sourceMappingURL=testimonials-slider.1b51120d.js.map
